import toast from 'react-hot-toast'
import CustomToast from './custom-toast'
import {
  faCircleCheck,
  faCircleXmark,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'

export const showToast = {
  success: (title: string, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon={faCircleCheck}
        iconClass="text-emerald-500"
        bgIcon="bg-emerald-500/10"
        accentClass="bg-emerald-500"
        title={title}
        message={message}
      />
    )),

  error: (title: string, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon={faCircleXmark}
        iconClass="text-red-500"
        bgIcon="bg-red-500/10"
        accentClass="bg-red-500"
        title={title}
        message={message}
      />
    )),

  warning: (title: string, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon={faTriangleExclamation}
        iconClass="text-amber-500"
        bgIcon="bg-amber-500/10"
        accentClass="bg-amber-500"
        title={title}
        message={message}
      />
    )),
}
